<template>
    <ais-instant-search
        :search-client="searchClient"
        :index-name="productsIndex"
        :routing="routing"
    >
        <ais-configure
            :hits-per-page.camel="24"
            :ignore-plurals.camel="true"
        />

        <ais-current-refinements
            v-slot="{ items }"
            :included-attributes="['roam_products_categories.lvl0']"
        >
            {{ setEventsActive(items) }}
        </ais-current-refinements>

        <div class="p-search__query">
            <ais-search-box placeholder="Search for…" />
            <span>in</span>
            <ais-menu-select
                v-slot="{ items, canRefine, refine }"
                attribute="roam_products_regions.lvl0"
            >
                <Select
                    :items="items"
                    :canRefine="canRefine"
                    :refine="refine"
                    placeholder="Everywhere"
                />
            </ais-menu-select>
        </div>

        <div class="p-search__filters">
            <Categories />
            <RoamDateSelect v-if="isEventsActive" attribute="roam_products_eventDates" />
        </div>

        <div class="mb-12 sm:mb-32">
            <ais-hits>
                <template slot="item" slot-scope="{ item }">
                    <ProductCard :item="item" />
                </template>
            </ais-hits>

            <ais-pagination :show-first="false" :show-last="false" @page-change="scrollTop" />
        </div>
    </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';
import routing from './routing';
import ProductCard from './components/ProductCard.vue';
import Categories from './components/Categories.vue';
import RoamDateSelect from './components/DateSelect.vue';
import Select from './components/Select.vue';

export default {
    name: 'ListingsSearch',

    components: {
        ProductCard,
        Categories,
        RoamDateSelect,
        Select,
    },

    data() {
        return {
            searchClient: algoliasearch(window.algolia.id, window.algolia.key),
            routing: routing('products_default'),
            selectedIndex: 'products_default',
            query: null,
            isEventsActive: false,
        };
    },

    computed: {
        productsIndex() {
            return this.isEventsActive
                ? 'products_default_events'
                : 'products_default';
        },
    },

    methods: {
        setEventsActive(refinements) {
            this.isEventsActive = refinements.some(
                (refinement) => refinement.attribute === 'roam_products_categories.lvl0'
                && refinement.refinements.some((cat) => cat.value === "What's On"),
            );
        },

        scrollTop() {
            const el = this.$refs.search;
            el.scrollIntoView();
        },

        handleSearchInput(value, refine) {
            refine(value);
            this.query = value;
        },
    },
};
</script>
